import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPatient } from '../models/patient.model';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class PatientsService {

  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/patients';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }

  getPatients(pageNumber: number, pageSize: number, orderBy: string, sortBy: string, search: string, module: string): Observable<IPatient> {
    return this.http.get<IPatient>(`${this.baseUrl}`, {
      params: {
        pageNumber,
        pageSize,
        orderBy,
        sortBy,
        search,
        module
      }
    });
  }

  /**
   * Exporta a lista de pacientes da clínica em formato CSV.
   * Utiliza os mesmos filtros aplicados na listagem (ordenação, busca e módulo).
   */
  exportPatientsCsv(search: string, orderBy: string, sortBy: string, module: string): Observable<HttpResponse<Blob>> {
    const url = `${this.baseUrl}/export`;
    return this.http.get(url, {
      params: {
        orderBy,
        sortBy,
        search,
        module
      },
      responseType: 'blob',
      observe: 'response'
    });
  }

  getPatientById(id: string): Observable<IPatient> {
    return this.http.get<IPatient>(`${this.baseUrl}/${id}`);
  }

  create(patient: IPatient): Observable<IPatient> {
    return this.http.post<IPatient>(`${this.baseUrl}`, patient);
  }

  update(id: string, patient: IPatient): Observable<IPatient> {
    return this.http.put<IPatient>(`${this.baseUrl}/${id}`, patient);
  }

  search(searchTerm: string): Observable<IPatient> {
    return this.http.get<IPatient>(`${this.baseUrl}/search`, {
      params: {
        searchTerm
      }
    });
  }
}
